// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getCouponProviderRequest: ['data'],
  getCouponProviderSuccess: ['data'],
  getCouponProviderFailure: ['err'],

  postCouponProviderRequest: ['data'],
  postCouponProviderSuccess: ['data'],
  postCouponProviderFailure: ['err'],

  putCouponProviderRequest: ['data'],
  putCouponProviderSuccess: ['data'],
  putCouponProviderFailure: ['err'],

  deleteCouponProviderRequest: ['data'],
  deleteCouponProviderSuccess: ['data'],
  deleteCouponProviderFailure: ['err']
})

export const CouponProviderTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: null,
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
export const request = (state: Object) => state.merge({ fetching: true, err: null, success: null, spreadsheet: null })

export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
  })

export const failure = (state: Object, { err }: Object) => state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_COUPON_PROVIDER_REQUEST]: request,
  [Types.GET_COUPON_PROVIDER_SUCCESS]: success,
  [Types.GET_COUPON_PROVIDER_FAILURE]: failure,

  [Types.POST_COUPON_PROVIDER_REQUEST]: manipulateRequest,
  [Types.POST_COUPON_PROVIDER_SUCCESS]: manipulateSuccess,
  [Types.POST_COUPON_PROVIDER_FAILURE]: manipulateFailure,

  [Types.PUT_COUPON_PROVIDER_REQUEST]: manipulateRequest,
  [Types.PUT_COUPON_PROVIDER_SUCCESS]: manipulateSuccess,
  [Types.PUT_COUPON_PROVIDER_FAILURE]: manipulateFailure,

  [Types.DELETE_COUPON_PROVIDER_REQUEST]: manipulateRequest,
  [Types.DELETE_COUPON_PROVIDER_SUCCESS]: manipulateSuccess,
  [Types.DELETE_COUPON_PROVIDER_FAILURE]: manipulateFailure
})



// WEBPACK FOOTER //
// ./src/Redux/CouponProviderRedux.js